export type Expiration = "hour" | "day" | "week" | "never";
